import { useOutletContext } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Package, Users, Calendar, ShoppingCart, User, MessageSquare } from 'lucide-react';

const AdminDashboard = () => {
  const { stats } = useOutletContext();

  const statCards = [
    { label: 'Products', value: stats?.products || 0, icon: Package, color: 'bg-blue-500' },
    { label: 'Teachers', value: stats?.teachers || 0, icon: Users, color: 'bg-green-500' },
    { label: 'Events', value: stats?.events || 0, icon: Calendar, color: 'bg-purple-500' },
    { label: 'Orders', value: stats?.orders || 0, icon: ShoppingCart, color: 'bg-saffron-500' },
    { label: 'Users', value: stats?.users || 0, icon: User, color: 'bg-royal-500' },
    { label: 'Pending Requests', value: stats?.pending_requests || 0, icon: MessageSquare, color: 'bg-red-500' },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <h1 className="font-heading text-3xl font-bold text-gray-900">Dashboard</h1>
        <p className="text-gray-600">Welcome to the Khalsa Sidak Admin Panel</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {statCards.map((stat) => (
          <Card key={stat.label} className="hover:shadow-lg transition-shadow">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-500 text-sm font-medium">{stat.label}</p>
                  <p className="text-3xl font-bold text-gray-900 mt-1">{stat.value}</p>
                </div>
                <div className={`w-12 h-12 ${stat.color} rounded-xl flex items-center justify-center`}>
                  <stat.icon className="w-6 h-6 text-white" />
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="mt-8 grid lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle className="font-heading">Quick Actions</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <a href="/admin/products" className="block p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
              <div className="flex items-center gap-3">
                <Package className="w-5 h-5 text-saffron-500" />
                <span className="font-medium">Add New Product</span>
              </div>
            </a>
            <a href="/admin/events" className="block p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
              <div className="flex items-center gap-3">
                <Calendar className="w-5 h-5 text-saffron-500" />
                <span className="font-medium">Create Event</span>
              </div>
            </a>
            <a href="/admin/requests" className="block p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
              <div className="flex items-center gap-3">
                <MessageSquare className="w-5 h-5 text-saffron-500" />
                <span className="font-medium">Review Service Requests</span>
              </div>
            </a>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="font-heading">Platform Info</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex justify-between items-center py-2 border-b">
              <span className="text-gray-600">Platform</span>
              <span className="font-medium">Khalsa Sidak</span>
            </div>
            <div className="flex justify-between items-center py-2 border-b">
              <span className="text-gray-600">Region</span>
              <span className="font-medium">Global Sikh Community</span>
            </div>
            <div className="flex justify-between items-center py-2 border-b">
              <span className="text-gray-600">Email</span>
              <a href="mailto:Khalsasidak13@gmail.com" className="font-medium text-sm text-saffron-600 hover:text-saffron-700">Khalsasidak13@gmail.com</a>
            </div>
            <div className="flex justify-between items-center py-2">
              <span className="text-gray-600">Phone</span>
              <a href="tel:+12404747537" className="font-medium text-saffron-600 hover:text-saffron-700">240-474-7537</a>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminDashboard;
